  import qs from 'qs'
  import { showData } from '@/assets/js/api/index'

  const config = function (cfg,option) {
    let nonceStr = cfg.nonceStr;
    let timestamp = cfg.timestamp;
    let signature = cfg.signature;
    let appid = cfg.appid;

    let title = option.title;
    let link = option.link;
    let desc = option.desc;
    let img = option.img ? option.img : '';

    wx.config({
      debug: false,
      appId: appid,
      timestamp:timestamp,
      nonceStr: nonceStr,
      signature: signature,
      jsApiList: ['checkJsApi',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
        'uploadImage',
        'chooseImage',
        'previewImage',
      ],
      openTagList: ['wx-open-launch-weapp']
    });

    wx.ready(function(){
      wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: link, // 分享链接
        imgUrl : img, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareAppMessage({
        title: title,
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl : img, // 分享图标
        type: '',
        dataUrl: '',
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
      wx.onMenuShareQQ({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });

      //wx.hideAllNonBaseMenuItem();
      wx.showMenuItems({
        menuList: ['appMessage','menuItem:share:timeline','menuItem:share:appMessage','menuItem:share:qq'] // 要显示的菜单项，所有menu项见附录3
      });

      wx.hideMenuItems({
        menuList:['menuItem:copyUrl']
      });
    });
  }

    //微信自定义分享js-sdk接口调用
    export const weixinShow = function (option){
        let url = window.location.href;
        url = url.replace(/\&/g,"@@@");//针对url有多个参数
        showData(url,function(result){
            config(result,option);
        });
    };

    // 注入权限
    export const weixinConfig = function (){
      let url = window.location.href;
      url = url.replace(/\&/g,"@@@");//针对url有多个参数
      showData(url,function(result){
          config(result,{});
      });
  };

    // 上传图片
    export const imagePort = function (count,success){
      wx.ready(function(){
        wx.chooseImage({
          count: count, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
          success:success
          // success: function (res) {
          // var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          // }
        });
      })
    };
    export const uploadImage = function (localId,success){
      wx.ready(function(){
        wx.uploadImage({
          localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 0, // 默认为1，显示进度提示
          success:success
          // success: function (res) {
          //   var serverId = res.serverId; // 返回图片的服务器端ID
          // }
        });
      })
    };
    //预览图片
    export const previewImage = function (current,urls){
      wx.ready(function(){
        wx.previewImage({
          current: current, // 当前显示图片的http链接
          urls: urls // 需要预览的图片http链接列表
        });
      })
    };

    // 微信网页授权
    export const wxAuth = scope => {
      const queryString = {
        appid: 'wx26838485fbcf5228',
        redirect_uri: `http://test.main.newrank.cn/m/login`,
        response_type: 'code',
        scope: `snsapi_${scope}`,
        state: window.location.href.replace('?reselect=true', ''),
      }
      window.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?${qs.stringify(
          queryString
        )}#wechat_redirect`
      )
    }



// WEBPACK FOOTER //
// ./src/assets/js/common/untils.js